import script from "./Info.vue?vue&type=script&lang=ts&setup=true"
export * from "./Info.vue?vue&type=script&lang=ts&setup=true"

import "./Info.vue?vue&type=style&index=0&id=14f7ef5f&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f7ef5f"]])

export default __exports__